
import { VueLanguageMixin } from "../../lib/language-ui";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CardBrandTheme } from "./internal/types";

@Component
export default class PayCardImage extends Vue {
  @Prop({ default: "54vw" }) height!: string;
  @Prop({ default: "" }) cardName!: string;
  @Prop({ default: "" }) cardNumber!: string;
  @Prop({ default: "" }) cardExpiry!: string;
  @Prop({ default: "" }) cardCvv!: string;
  @Prop({ default: { color: "grey", ccicon: "", ccsingle: "" } }) cardBrand!: CardBrandTheme;

  flipped = false;

  get lang() {
    return (this.$root as VueLanguageMixin).lang;
  }

  get svgName() {
    if (!this.cardName) return this.lang.fCardNamePlaceholder;
    return this.cardName;
  }

  get svgCardNumber() {
    if (!this.cardNumber) return this.lang.fPANPlaceholder;
    return this.cardNumber;
  }

  get svgExpire() {
    if (!this.cardExpiry) return this.lang.fExpirePlaceholder;
    return this.cardExpiry;
  }

  get svgCVV() {
    if (!this.cardCvv) return this.lang.fCvvPlaceholder;
    return this.cardCvv;
  }

  setFlipped(value: boolean) {
    this.flipped = value;
  }

  get cardContainerStyle() {
    return `height: ${this.height}`;
  }
}
